import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axiosInstance";
import Select from "react-select";

const SpeakerFilters = ({
  filters,
  countries,
  cities,
  industries,
  specialities,
  priceRanges,
  handleInputChange,
  resetFilters,
  handleSearch,
  fetchCities,
  onFilterChange,
}) => {
  const { t, i18n } = useTranslation();
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

  const currentLang = i18n.language;
  const getLabel = (item) =>
    currentLang === "ar" ? item.arabicName : item.englishName;

  return (
    <div className="card mb-4">
      <div className="card-body">
        <h6 className="card-title mb-3">{t("search_speakers")}</h6>

        <div className="row">
          <div className="col-lg-8 mb-3">
            <div className="input-group">
              <span className="input-group-text">
                <i className="fas fa-search"></i>
              </span>
              <input
                type="text"
                className="form-control"
                id="keyword"
                placeholder={t("search_placeholder")}
                value={filters.keyword}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="col-lg-4 mb-3">
            <button
              type="button"
              className="btn btn-primary w-100"
              onClick={handleSearch}
            >
              {t("Search")}
            </button>
          </div>
        </div>

        <button
          className="btn btn-link text-primary-custom p-0 mb-3"
          type="button"
          onClick={() => setShowAdvancedFilters((prev) => !prev)}
        >
          <i className="fas fa-sliders me-1"></i> {t("advanced_filters")}
        </button>

        {/* <div className="collapse" id="advancedFilters"> */}
        {showAdvancedFilters && (
          <div className="row g-3">
            {/* البحث عن طريق الدولة */}
            <div className="col-md-4">
              <label className="form-label">{t("country")}</label>
              <Select
                id="country"
                options={countries.map((c) => ({
                  value: c.id,
                  label: getLabel(c),
                }))}
                value={
                  filters.countryIds.length > 0
                    ? countries
                        .map((c) => ({ value: c.id, label: getLabel(c) }))
                        .find(
                          (option) => option.value === filters.countryIds[0]
                        )
                    : null
                }
                onChange={(selectedOption) => {
                  const value = selectedOption ? [selectedOption.value] : [];
                  const newFilters = {
                    ...filters,
                    countryIds: value,
                    cityIds: [],
                  };
                  onFilterChange(newFilters);
                  fetchCities(value[0]); // أول عنصر فقط
                }}
                isClearable
                placeholder={t("all")}
              />
            </div>
            {/* البحث عن طريق المدينة */}
            <div className="col-md-4">
              <label className="form-label">{t("city")}</label>
              <Select
                id="city"
                options={cities.map((c) => ({
                  value: c.id,
                  label: getLabel(c),
                }))}
                value={
                  filters.cityIds.length > 0
                    ? cities
                        .map((c) => ({ value: c.id, label: getLabel(c) }))
                        .find((option) => option.value === filters.cityIds[0])
                    : null
                }
                onChange={(selectedOption) => {
                  const value = selectedOption ? [selectedOption.value] : [];
                  const newFilters = { ...filters, cityIds: value };
                  onFilterChange(newFilters);
                }}
                isClearable
                placeholder={t("all")}
              />
            </div>

            {/* البحث عن طريق المجالات */}
            <div className="col-md-4">
              <label className="form-label">{t("industries")}</label>
              <Select
                id="industry"
                isMulti
                options={industries.map((i) => ({
                  value: i.id,
                  label: getLabel(i),
                }))}
                value={industries
                  .filter((i) => filters.industryIds?.includes(i.id))
                  .map((i) => ({
                    value: i.id,
                    label: getLabel(i),
                  }))}
                onChange={(selectedOptions) => {
                  const values = selectedOptions
                    ? selectedOptions.map((o) => o.value)
                    : [];
                  const newFilters = { ...filters, industryIds: values };
                  onFilterChange(newFilters);
                }}
                isClearable
                placeholder={t("all")}
              />
            </div>

            {/* البحث عن طريق التخخصات */}
            <div className="col-md-4">
              <label className="form-label">{t("specialities")}</label>
              <Select
                id="speciality"
                isMulti
                options={specialities.map((s) => ({
                  value: s.id,
                  label: getLabel(s),
                }))}
                value={specialities
                  .filter((s) => filters.specialityIds?.includes(s.id))
                  .map((s) => ({
                    value: s.id,
                    label: getLabel(s),
                  }))}
                onChange={(selectedOptions) => {
                  const values = selectedOptions
                    ? selectedOptions.map((o) => o.value)
                    : [];
                  const newFilters = { ...filters, specialityIds: values };
                  onFilterChange(newFilters);
                }}
                isClearable
                placeholder={t("all")}
              />
            </div>

            {/* البحث بالغة */}
            <div className="col-md-2">
              <label className="form-label">{t("language")}</label>
              <Select
                id="language"
                options={[
                  { value: "Arabic", label: t("arabic") },
                  { value: "English", label: t("english") },
                ]}
                value={
                  filters.language
                    ? [
                        { value: "Arabic", label: t("arabic") },
                        { value: "English", label: t("english") },
                      ].find((opt) => opt.value === filters.language)
                    : null
                }
                onChange={(selectedOption) => {
                  const value = selectedOption?.value || "";
                  const newFilters = { ...filters, language: value };
                  onFilterChange(newFilters);
                }}
                isClearable
                placeholder={t("all")}
              />
            </div>

            {/* البحث بالجنس */}
            <div className="col-md-2">
              <label className="form-label">{t("gender")}</label>
              <Select
                id="gender"
                options={[
                  { value: "Male", label: t("male") },
                  { value: "Female", label: t("female") },
                ]}
                value={
                  filters.gender
                    ? [
                        { value: "Male", label: t("male") },
                        { value: "Female", label: t("female") },
                      ].find((opt) => opt.value === filters.gender)
                    : null
                }
                onChange={(selectedOption) => {
                  const value = selectedOption?.value || "";
                  const newFilters = { ...filters, gender: value };
                  onFilterChange(newFilters);
                }}
                isClearable
                placeholder={t("all")}
              />
            </div>

            {/* البحث بالتكلفة */}
            <div className="col-md-4">
              <label className="form-label">{t("price")}</label>

              <Select
                id="priceRangeId"
                options={priceRanges.map((p) => ({
                  value: p.price,
                  label: p.price,
                }))}
                value={
                  filters.priceRangeId
                    ? priceRanges
                        .map((p) => ({ value: p.price, label: p.price }))
                        .find((option) => option.value === filters.priceRangeId)
                    : null
                }
                onChange={(selectedOption) => {
                  const value = selectedOption?.value || "";
                  const newFilters = { ...filters, priceRangeId: value };
                  onFilterChange(newFilters);
                }}
                isClearable
                placeholder={t("all")}
              />
            </div>
            <div className="d-flex justify-content-end gap-2 mt-3">
              <button
                className="btn btn-outline-secondary"
                onClick={resetFilters}
              >
                {t("reset_filters")}
              </button>
              <button className="btn btn-primary w-50" onClick={handleSearch}>
                {t("Search")}
              </button>
            </div>
          </div>
        )}

        {/* </div> */}
      </div>
    </div>
  );
};

export default SpeakerFilters;
